import { c as i } from "../../../../index.esm-BeDSGXP5.js";
import { css as t, keyframes as n } from "styled-components";
const e = /* @__PURE__ */ n([
  "from{opacity:0;}to{opacity:1;}"
]), m = {
  outerWrapper: /* @__PURE__ */ t([
    "z-index:9999;inset:0;position:fixed;overflow-y:scroll;animation-name:",
    ";animation-duration:0.2s;animation-timing-function:ease-out;"
  ], e),
  innerWrapper: /* @__PURE__ */ t([
    "position:relative;width:100%;min-height:100%;display:flex;align-items:center;justify-content:center;"
  ]),
  backdrop: /* @__PURE__ */ t([
    "height:100%;width:100%;position:absolute;inset:0;background-color:rgba(0,0,0,0.3);"
  ]),
  base: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " position:sticky;width:52.6rem;max-width:100%;"
  ], i({
    padding: [
      "sm",
      null,
      "lg"
    ],
    marginY: "md",
    backgroundColor: o.componentColors.modal.background
  })),
  closeButton: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " float:right;"
  ], i({
    fontSize: [
      o.fontSizes.textMediumMobile,
      null,
      o.fontSizes.textSmallDesktop
    ],
    marginLeft: "md",
    marginBottom: "md"
  })),
  icon: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " height:5.6rem;width:5.6rem;"
  ], i({
    color: o.componentColors.modal.icon,
    marginBottom: "sm"
  })),
  heading: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " ",
    " ",
    ""
  ], o.components.text.base, o.components.text.large, i({
    marginBottom: "sm"
  })),
  divider: ({ theme: o }) => /* @__PURE__ */ t([
    "",
    " height:2px;"
  ], i({
    backgroundColor: o.componentColors.modal.divider,
    marginY: "sm"
  }))
};
export {
  m as default
};
